export default __webpack_public_path__ + "static/media/icons-bg32.5921267c.jpg";